import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { exchangeCode, useAuth } from '@/hooks/use-auth';

export default function AuthCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const code = params.get('code');
    const err = params.get('error');
    if (err) {
      toast.error(`Google sign-in cancelled: ${err}`);
      navigate('/login', { replace: true });
      return;
    }
    if (!code) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        await exchangeCode(code);
        await refresh();
        toast.success('Signed in');
        navigate('/', { replace: true });
      } catch (e: unknown) {
        const msg = e instanceof Error ? e.message : 'Sign-in failed';
        toast.error(msg);
        navigate('/login', { replace: true });
      }
    })();
  }, [params, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center text-muted text-sm">
      Finishing sign-in...
    </div>
  );
}
